<template>
  <div id="kds">
    <button class="btn" :class="{ 'btn-primary': !showingCompleted }" @click="showingCompleted = false"
      style="margin-right: 10px; margin-bottom: 10px;">Open orders</button>
    <button class="btn" :class="{ 'btn-primary': showingCompleted }" @click="showingCompleted = true">Completed</button>
    <div class="kds__grid">
      <KDSInvoice @showModal="showModal" v-for="n in 8" :key="`invoice-${n}`" :showingCompleted="showingCompleted"></KDSInvoice>
    </div>
    <ModalKDSOrderDetails ref="modal"></ModalKDSOrderDetails>
  </div>
</template>

<script>
  import ModalKDSOrderDetails from "@/components/pos/ModalKDSOrderDetails.vue";
  import KDSInvoice from "@/components/pos/KDSInvoice.vue";

  export default {
    name: "KitchenDisplaySystem",
    components: { ModalKDSOrderDetails, KDSInvoice },
    data() {
      return {
        showingCompleted: false
      };
    },
    methods: {
      showModal() {
        this.$refs.modal.show();
      }
    }
  };
</script>

<style lang="scss" scoped>
#kds {
  padding: 30px;
  height: 100%;
}

.kds__grid {
  height: calc(100% - 50px);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 20px;
}
</style>
